import React, { useEffect, useState } from "react"
import EvaluationAssistanceScreen from "../../screen/EvaluationAssistanceScreen"
import { useParams } from "react-router-dom"
import Send from "../../core/communication"

const EvaluationAssistanceContainer = () => {
  const [selectedOption, setSelectedOption] = useState("")
  const [success, setSuccess] = useState(false)
  const { id } = useParams()

  useEffect(() => {
    getUserLocation()
  }, [])

  const getUserLocation = async () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords
          const geo = { latitude, longitude }
          // const response = await Send.post(`/nps/serviceEvaluation/${id}`, { geo })
          // console.log({ response })
        },
        (error) => {
          console.error("Error getting user location:", error)
        },
      )
    } else {
      console.error("Geolocation is not supported by this browser.")
    }
  }

  const handleChange = (id) => {
    setSelectedOption(id)
    sendEvaluation(id)
  }

  const resetEvaluation = () => {
    setSelectedOption("")
    setSuccess(false)
  }

  const sendEvaluation = async (value) => {
    try {
      const response = await Send.get(`/nps/serviceEvaluation/${id}/${value}`)

      if (response.success) {
        setSuccess(true)
      }

      console.log("ERRO", response)
    } catch (error) {
      console.log("ERROR")
    }
  }

  return (
    <EvaluationAssistanceScreen {...{ selectedOption, handleChange, resetEvaluation, success }} />
  )
}

export default EvaluationAssistanceContainer
